import React, { useCallback } from 'react'
import { Dropdown } from '@scentregroup/ui'

export enum SortOption {
  RECENT = 'recent',
  PRICE_LOW_HIGH = 'price-asc',
  PRICE_HIGH_LOW = 'price-desc',
  SORT_A_Z = 'alpha-asc',
  SORT_Z_A = 'alpha-desc',
  BRAND_SORT_A_Z = 'brand-alpha-asc',
  BRAND_SORT_Z_A = 'brand-alpha-desc',
  RECOMMENDED = 'recommended',
  RECOMMENDED_BALANCED = 'recommended-balanced',
  RECOMMENDED_COMBINED_ANALYTICS = 'recommended-combined-analytics',
  RECOMMENDED_COMBINED_NOISY = 'recommended-combined-noisy',
  RECOMMENDED_CONVERSION_BASED = 'recommended-conversion-based',
  RECOMMENDED_CTR_BASED = 'recommended-ctr-based',
}

export const SortOptionDefault = SortOption.RECOMMENDED

export function sortOptionFromString(str: string): SortOption | undefined {
  if (
    Object.values(SortOption)
      .map(v => v as string)
      .includes(str)
  ) {
    return str as SortOption
  }
  return undefined
}

export type DropdownOption = {
  label: string
  value: string
}

export function sortOptions({
  defaultSortByLabel,
}: {
  defaultSortByLabel: string
}): DropdownOption[] {
  const options = [
    { label: `Sort by: ${defaultSortByLabel}`, value: SortOption.RECENT },
    {
      label: 'Sort by: Price low to high',
      value: SortOption.PRICE_LOW_HIGH,
    },
    {
      label: 'Sort by: Price high to low',
      value: SortOption.PRICE_HIGH_LOW,
    },
    { label: 'Sort by: Product Name A-Z', value: SortOption.SORT_A_Z },
    { label: 'Sort by: Product Name Z-A', value: SortOption.SORT_Z_A },
    { label: 'Sort by: Brand A-Z', value: SortOption.BRAND_SORT_A_Z },
    { label: 'Sort by: Brand Z-A', value: SortOption.BRAND_SORT_Z_A },
  ]

  return [
    {
      label: 'Sort by: Recommended',
      value: SortOption.RECOMMENDED,
    },
  ].concat(options)
}

export const DROPDOWN_OPTIONS: DropdownOption[] = sortOptions({
  defaultSortByLabel: 'Recent',
})

const SortOptionsDropdown: React.FunctionComponent<
  React.PropsWithChildren<{
    option: SortOption
    onChange: (option: SortOption) => void
    onClick?: (e?: React.SyntheticEvent<HTMLSelectElement>) => void
    options?: DropdownOption[]
  }>
> = ({
  option,
  onChange,
  onClick = () => void {},
  options = DROPDOWN_OPTIONS,
}) => {
  const onChangeDropdown = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      const sortOption = sortOptionFromString(event.target.value)
      if (sortOption) {
        onChange(sortOption)
      }
    },
    [onChange]
  )

  return (
    <Dropdown
      id="sort-options"
      size="SMALL"
      options={options}
      value={option}
      onChange={onChangeDropdown}
      onClick={onClick}
    />
  )
}

export default SortOptionsDropdown
